// @mui
import AppDialog from './AppDialog';
import ImportantNotice from './ImportantNotice';
// utils

// ----------------------------------------------------------------------

export default function DeleteModal(props) {
    return (
        <>
            <AppDialog
                open={props.open}
                close={() => props.close()}
                title={props?.title}
                positiveTitle={props.positiveTitle ?? `Delete`}
                positivePress={() => props.submit()}
                positiveButtonStyle={props.positiveButtonStyle || { backgroundColor: '#D13536', color: "white", border: "none", borderRadius: "20px" }}
                negativePress={() => props.close()}
                negativeTitle={'Cancel'}
                width={props.width || '50%'}
                negativeButtonStyle={props.negativeButtonStyle || { color: "#808588", backgroundColor:"#F9F9F9", border: "0px solid black", width: "auto", borderRadius: "20px"}}
                isMobile={props.isMobile}
                mobileSizeModalMaxHeight={props.mobileSizeModalMaxHeight}
            >
                <div className="pb-0 pt-3">
                    {
                        props?.message && props.message
                    }
                </div>
            </AppDialog>
        </>


    );
}
